import { BaseController } from "@shared/basecontroller.controller";
import { FilterModel } from "./model/filter.model";

export class BetsController extends BaseController {
  constructor(BetOverviewApiService, PageService) {
    'ngInject';

    super();

    this.PageService = PageService;
    this.BetOverviewApiService = BetOverviewApiService;
  }

  $onInit() {
    this.payload = this.PageService.getQueryParameters();
    this.filterModel = new FilterModel(this.payload);

    this.BetOverviewApiService.getBets(this.filterModel.toPayload()).then(betListing => {
      this.betListing = betListing;
    });
  }

  onPaginate(offset) {
    this.filterModel.offset = offset;
    this.BetOverviewApiService.getBets(this.filterModel.toPayload()).then(betListing => {
      this.betListing = betListing;
    });
  }

  exportToCSV() {
    this.BetOverviewApiService.exportToCSV(this.filterModel.toPayload());
  }
}

export default BetsController;


// WEBPACK FOOTER //
// ./client/app/pages/customer/betoverview/component/bets/bets.controller.js